import { Box, Heading, Text, VStack } from '@chakra-ui/react'
import { useAppSelector } from '../../app/typedReduxHooks'
import Card from '../../common/components/Card'
import { SelectedPatientIdentity } from './SelectedPatientIdentity'

export const EhrResolvedPatientPanel = () => {
  const patient = useAppSelector((state) => state.patientDetail.selectedPatient)

  return (
    <VStack alignItems="stretch">
      <Heading as="h4" size="md">
        Patient
      </Heading>
      <Card p="3">
        <VStack align="stretch" spacing={4}>
          <Box>
            <Text fontWeight="bold" color="green.700">
              EHR patient ready
            </Text>
            <Text>🔒 Patient identity is fixed for this EHR session</Text>
          </Box>
          <SelectedPatientIdentity patient={patient} />
        </VStack>
      </Card>
    </VStack>
  )
}
